module.exports = "/shiftTasks/components/taskTemplates/taskTemplates-9610d0.html";